module.exports = __webpack_public_path__ + "img/back_address1.acee6fa2.png";